import DailyOutputReportPage from "./DailyOutputReportPage";

export default function DailyTeamOutputPage() {
  return (
    <DailyOutputReportPage
      title="Daily Team Output"
      label="Team"
      endpoint="/reports/daily-team-output"
      detailEndpoint="/reports/daily-team-output/details"
      detailParamName="team"
      exportEndpoint="/reports/daily-team-output/export"
      filterEndpoint="/reports/teams-list"
      filterLabel="Team"
      filterParamName="teams"
      exportFilenamePrefix="Daily_Team_Output"
      showCompanyFilter
    />
  );
}
